import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { CreativeTemplate } from '../../../../shared/models/creativeTemplate';
import { CreativeTemplateService } from '../../../../shared/services/creativeTemplate.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgeRange } from '../../../models/ageRange';
import { AgeRangeService } from '../../../services/ageRange.service';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { ValidationService } from '../../../services/validation.service';
import { BrandMonthConversionService } from '../../../services/brandMonthConversion.service';

@Component({
  selector: 'app-creative-template-add-form',
  templateUrl: './creative-template-add.component.html'
})

export class CreativeTemplateAddFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() brandId: number;
  @Input() model: CreativeTemplate;

  editForm: FormGroup; 
  submitted = false;  
  public ageRangeList: AgeRange[];  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public campaignTypeList: CampaignType[];
  public monthsList: any[];
  public monthsConversionList: any[];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private creativeTemplateService: CreativeTemplateService,
    private ageRangeService: AgeRangeService,
    private storeLocationService: StoreLocationService,
    private notification: MatSnackBar,
    private campaignTypeService: CampaignTypeService,
    private brandMonthConversionService: BrandMonthConversionService) { }

  // on component load
  ngOnInit() {

    // bind age ranges dropdown
    this.ageRangeService.getAll().subscribe(result => {
      this.ageRangeList = result;
    });

    // bind campaign dropdown
    this.campaignTypeService.getAll().subscribe(result => {
      this.campaignTypeList = result;
    });

    // bind store locations dropdown
    this.storeLocationService.getAll(this.brandId).subscribe(result => {
      this.storeLocationList = result;
    });

    // get all months
    this.brandMonthConversionService.getAll(this.brandId).subscribe(result => {
      this.monthsConversionList = result.filter((x, i, arr) => {
        return arr.indexOf(arr.find(t => t.campaignTypeId === x.campaignTypeId && t.convertMonth === x.convertMonth)) === i;
      }).map(b => ({ campaignTypeId: b.campaignTypeId, months: b.convertMonth }));

      if (this.model !== undefined) {
        this.onChangeCampaignType(this.model.campaignTypeId);
      }
    });

    // build form
    if (this.model === undefined) {
      // build form model
      this.editForm = this.formBuilder.group({
        frontImage: [''],
        frontCTA: [''],
        frontOffer: [''],
        frontLogo: [''],
        backLogo: [''],
        backCTA: [''],
        backBackground: [''],
        backTopLeftCopy: [''],
        backOfferBlock: [''],
        backStoreBlock: [''],
        backBottomLeftCopy: [''],
        //custom1: [''],
        //custom2: [''],
        //custom3: [''],
        //custom4: [''],
        //custom5: [''],
        gender: [null, Validators.required],
        months: [0],
        style: [''],
        brandId: [this.brandId],
        campaignTypeId: [null, [Validators.required, Validators.min(1)]],
        ageRangeId: [null, [Validators.required, Validators.min(1)]]
      });
    }
    else {

       
      // build form model
      this.editForm = this.formBuilder.group({
        frontImage: [this.model.frontImage],
        frontCTA: [this.model.frontCTA],
        frontOffer: [this.model.frontOffer],
        frontLogo: [this.model.frontLogo],
        backLogo: [this.model.backLogo],
        backCTA: [this.model.backCTA],
        backBackground: [this.model.backBackground],
        backTopLeftCopy: [this.model.backTopLeftCopy],
        backOfferBlock: [this.model.backOfferBlock],
        backStoreBlock: [this.model.backStoreBlock],
        backBottomLeftCopy: [this.model.backBottomLeftCopy],
        //custom1: [this.model.custom1],
        //custom2: [this.model.custom2],
        //custom3: [this.model.custom3],
        //custom4: [this.model.custom4],
        //custom5: [this.model.custom5],
        gender: [this.model.gender || null, Validators.required],
        months: [this.model.months],
        style: [this.model.style],
        brandId: [this.brandId],
        campaignTypeId: [this.model.campaignTypeId, [Validators.required, Validators.min(1)]],
        ageRangeId: [this.model.ageRangeId, [Validators.required, Validators.min(1)]]
      });

    }
  }
   
  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 
      const model = this.editForm.value as CreativeTemplate;
      model.brandId = +this.editForm.value['brandId'];
      model.campaignTypeId = +this.editForm.value['campaignTypeId'];
      model.ageRangeId = +this.editForm.value['ageRangeId'];
      model.months = +this.editForm.value['months'];

      this.creativeTemplateService.add(model).subscribe(creativeTemplate => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The entry was successuly updated!`, 'Okay!') 
      }); 
  }

  // change campaign type
  onChangeCampaignType(campaignTypeId: number) {
    this.monthsList = this.monthsConversionList.filter(x => {
      return x.campaignTypeId === +campaignTypeId;
    }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
